export default __webpack_public_path__ + "static/media/cocacolaLogo.765bae6e.png";